import React from 'react';
import { Typography, Box, Avatar } from '@mui/material';
import { Circle as CircleIcon, Shield as ShieldIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

/** For admins: repeated wrong merge codes, a blocked account, or a request to reopen one. */
export default function SecurityAlertCard({ notification, onMarkRead }) {
  const navigate = useNavigate();
  const p = notification.payload || {};
  const open = () => {
    if (!notification.is_read && onMarkRead) onMarkRead();
    navigate('/admin/verify-memberships/?tab=blocked');
  };
  return (
    <Box onClick={open} sx={{
      display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 1.25, px: 2, borderBottom: '1px solid', borderColor: 'divider',
      backgroundColor: notification.is_read ? 'transparent' : 'rgba(185,28,28,0.06)', cursor: 'pointer',
      '&:hover': { backgroundColor: 'action.selected' },
    }}>
      <Avatar sx={{ width: 34, height: 34, mt: 0.25, bgcolor: '#b91c1c' }}><ShieldIcon sx={{ fontSize: 18 }} /></Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>{p.title || 'Security alert'}</Typography>
        <Typography variant="caption" color="text.secondary" display="block" noWrap>
          {[p.user_name, p.user_email, p.other_email && `tried ${p.other_email}`, p.wrong_codes && `${p.wrong_codes} wrong codes`].filter(Boolean).join(' · ')}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
          {formatDistanceToNow(new Date(notification.created), { addSuffix: true })}
        </Typography>
        {!notification.is_read && <CircleIcon sx={{ fontSize: 8, color: '#b91c1c' }} />}
      </Box>
    </Box>
  );
}
